/**
 * Every action related to analytics will be stored here as a helper function
 */
import ReactGA from "react-ga4";

import {
  GOOGLE_MEASURMENT_ID,
  IS_GOOGLE_ANALYTICS_ENABLED,
} from "@/config/config";

const isAnalyticsEnabled = () => {
  return Boolean(IS_GOOGLE_ANALYTICS_ENABLED) === true;
};
/**
 * Initialize Google Analytics
 */
export const initializeGA = () => {
  if (isAnalyticsEnabled()) {
    ReactGA.initialize(GOOGLE_MEASURMENT_ID);
  }
};

/**
 *  Push Page Tracking on Google Analytics
 *
 */
export const pageView = (pageTitle) => {
  //   Not supported with react-ga4 library.
  //   ReactGA.pageView(window.location.pathname + window.location.search);
  //   However, can send pageview as below
  if (isAnalyticsEnabled()) {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: pageTitle,
    });
  }
};

/**
 * Event - Add custom tracking event.
 * @param {string} category
 * @param {string} action
 * @param {string} label
 */
export const addGaEvent = (category, action, label) => {
  if (isAnalyticsEnabled()) {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};

export const sendErrorAnalytics = (config, label) => {
  const category = "retail-health";
  const action = config?.url;
  if (isAnalyticsEnabled()) {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};

export const sendAxiosDefaultErrorAnalytics = (category, config, label) => {
  const action = config?.url;
  if (isAnalyticsEnabled()) {
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};
